import { atom } from 'jotai'

export const movementsAtom = atom([])

export const movementsFilter = atom("")

export const movementPage = atom(0)